module.exports = __webpack_public_path__ + "static/img/game_bg_0.85275a13.png";